import React, { Suspense } from 'react';
import ChunkErrorBoundary from './ChunkErrorBoundary';
import ParkLoadingFallback from './ParkLoadingFallback';

/**
 * Wrapper pour les routes lazy avec gestion automatique des erreurs de chunks
 * ChunkErrorBoundary s'affiche en cas d'échec de chargement
 * Le fallback de route garde une surface visible pendant le chargement du chunk.
 */
const LazyRoute = ({ children, fallback = <ParkLoadingFallback /> }) => {
  return (
    <ChunkErrorBoundary>
      <Suspense fallback={fallback}>
        {children}
      </Suspense>
    </ChunkErrorBoundary>
  );
};

export default LazyRoute;
